"use client";

import { type ReactNode, createContext, useContext } from "react";

export interface ToastDetails {
  id?: string;
  color: "blue" | "malachite" | "yellow" | "red";
  icon?: ReactNode;
  children: ReactNode;
  duration?: number;
}

interface ToastContextValue {
  openToast: (details: ToastDetails) => void;
  closeToast: (contentOrId: string) => void;
}

const ToastContext = createContext<ToastContextValue | null>(null);

interface ToastContextProviderProps {
  children?: ReactNode;
  value: ToastContextValue;
}

export const ToastContextProvider = ({ children, value }: ToastContextProviderProps) => {
  return <ToastContext.Provider value={value}>{children}</ToastContext.Provider>;
};

export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToastContext must be used within a ToastProvider");
  }

  return context;
};
